module.exports = __webpack_public_path__ + "static/img/mzdsxyzgts.a314be4e.svg";